import { render, staticRenderFns } from "./tabDischargingTruckingUICustomLayout.vue?vue&type=template&id=5b4844bc&"
import script from "./tabDischargingTruckingUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabDischargingTruckingUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4844bc')) {
      api.createRecord('5b4844bc', component.options)
    } else {
      api.reload('5b4844bc', component.options)
    }
    module.hot.accept("./tabDischargingTruckingUICustomLayout.vue?vue&type=template&id=5b4844bc&", function () {
      api.rerender('5b4844bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTruckingUICustomLayout.vue"
export default component.exports